// The trial's days left (#211), for the sidebar footer beside Credits: read from Plan and billing once for an Owner,
// and shown only while the trial runs. Nobody else sees it.
import { useEffect, useState } from "react";
import type { Api } from "../api.js";

/** Whole days left in the running trial, or undefined when there is none to show. */
export function useTrialDaysLeft(api: Pick<Api, "billing">, owner: boolean): number | undefined {
  const [days, setDays] = useState<number | undefined>(undefined);
  useEffect(() => {
    if (!owner) return;
    let live = true;
    Promise.resolve()
      .then(() => api.billing())
      .then((page) => {
        if (live) setDays(page.trial.status === "running" ? page.trial.daysLeft : undefined);
      })
      // Plan and billing not answering shows no counter: the footer keeps Credits.
      .catch(() => undefined);
    return () => {
      live = false;
    };
  }, [api, owner]);
  return days;
}
